<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div>
        <a-layout class="layout">
            <a-layout-sider 
                :width="width" 
                class="layout_side" 
                v-model:collapsed="collapsed"
                collapsedWidth="55"
                collapsible
                @collapse="collapse"
            >
                <div class="logo">
                    <img src="@/assets/image/logo_icon.png" alt="" width="25" height="30" v-if="collapsed"/>
                    <img src="@/assets/image/logo.png" alt="" width="120" height="25" v-if="!collapsed" />
                    <div v-if="!collapsed" class="app_version">V {{ appVersion }}</div>
                </div>
                <!-- <div style="font-size:30px;font-weight:600;text-align:center;">HD-OTA</div> -->
                <Menu ref="refMenu" :isCollapsed="collapsed"></Menu>
            </a-layout-sider>
            <a-layout class="layout_right">
                <a-layout-header class="layout_header">
                    <div class="header_top">
                        <BreadCrumb class="breadCrumb" @collapsMenu="collapsMenu"></BreadCrumb>
                        <Avatar class="avatar"></Avatar>
                    </div>
                    <TabBar class="tabBar" v-if="showBreadCrumb"></TabBar>
                </a-layout-header>
                <a-layout-content class="layout_content">
                    <Main :cachedViews="cachedViews.value"></Main>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </div>
</template>

<script setup>
    import {ref,toRefs,onMounted,nextTick} from 'vue';

    import Menu from './component/Menu.vue';
    import BreadCrumb from './component/BreadCrumb.vue';
    import Avatar from './component/Avatar.vue';
    import TabBar from './component/TabBar.vue';
    import Main from './component/Main.vue';
    import { CarTwoTone } from '@ant-design/icons-vue';
    import {useTagsView} from '@/store/tagsView';

    const tagsViewStore = useTagsView()
    const { visitedViews, cachedViews } = toRefs(tagsViewStore)
    const collapsed = ref(false)
    const width = ref(200)
    const showBreadCrumb = ref(true)
    const clientWidth = ref(document.body.clientWidth)
    const refMenu = ref(null)
    const appVersion = __APP_VERSION__

    function collapse(val, type){
        width.value = val? 55 : 200
        collapsed.value = val
    }

    window.onresize = ()=>{
        clientWidth.value = document.body.clientWidth 
        const clientHeight = document.body.clientHeight

        if(clientWidth.value <= 1700 ){
            width.value = 55
            // headerRef.value.collapsed = true
            refMenu.value.collapsed = true
            collapsed.value = true
            showBreadCrumb.value = false
        }else{
            width.value = 200
            // headerRef.value.collapsed = false
            refMenu.value.collapsed = false
            collapsed.value = false
            showBreadCrumb.value = true
        }
        // localeStore.changeClientWidthAndHeight(clientWidth.value, clientHeight)
    }

    onMounted(()=>{
        nextTick(()=>{
            if(clientWidth.value <= 1700){
                width.value = 55
                refMenu.value.collapsed = true
                collapsed.value = true
                showBreadCrumb.value = false
            }else{
                width.value = 200
                refMenu.value.collapsed = false
                collapsed.value = false
                showBreadCrumb.value = true
            }
        })

        const layout_header_dom = document.querySelector('.layout_header')
        const layout_side_dom = document.querySelector('.layout_side')
        const ua = navigator.userAgent;
        const platform = navigator.platform;
        // 检测iPad（包括iPadOS 13及以上版本）
        if (ua.match(/iPad/i) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            layout_side_dom.style.paddingTop = 15 + 'px'
            layout_header_dom.style.paddingTop = 15 + 'px'
        }else{
            layout_side_dom.style.paddingTop = 0
            layout_header_dom.style.paddingTop = 0
        }
    })


</script>

<style lang="scss" scoped>
$header-bar-height:200px;
.layout{
    color: #fff;
    background: #001529;
    .layout_side{
        padding-top: 15px;
        height: 100vh;
        width: auto;
        box-shadow: 2px 0 6px rgb(0 21 41 / 35%);

        .logo{
            font-size: 20px;
            text-align: center;
            padding: 20px 10px 17px;
            .carTwoTone{
                margin-right: 8px;
            }
        }

        .app_version{
            font-size: 12px;
            color:#666;
            text-align: center;
            padding: 7px 10px;
        }
    }
    .layout_right{
        background: #fff;
    }
    .layout_header{
        background: #fff;
        padding: 15px 0 0 0;
        height: auto;
        box-shadow: 0px -2px 21px -15px #333;

        .header_top{
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #f1f1f1;

            .breadCrumb,.avatar{
                display: flex;
                flex: 3;
            }
            .breadCrumb{
                padding-left: 20px;
                align-items: center;
            }
            .avatar{
                flex: 1;
                justify-content: end;
                padding-right: 20px;
            }
        }
        .tabBar{
            padding-left: 20px;
        }
    }
    .layout_content{
        margin: 10px 1px 0; 
        padding: 0 10px;
        color: #333;
        overflow-y: scroll;
        height: calc(100vh - $header-bar-height);
    }
} 

::v-deep .ant-layout-header{
    line-height: 50px;
}
</style>